import { useState } from 'react';
import { Link } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Meta from '../common/Meta';
import Logo from '../images/privaposts-butterfly_220.png';
import PrivapostsLogo from '../images/privaposts_220.png';

import SocialInfluencer from '../images/Social_media_influ.png';
import ContentCreator from '../images/content_creators.png';
import UncensoredContent from '../images/uncensored_content.png';
import EarnPay from '../images/earn_pay.png';

import SignUp from '../images/Privaposts-Phone-icon.png';
import Price from '../images/Privaposts-price-tag-icon.png';
import PostContent from '../images/Privaposts-Media-icon.png';
import Promote from '../images/Privaposts-Social media-icons.png';
import EarnMoney from '../images/Privaposts-Bank-icon.png';

import Bonhammiano from '../images/Bonhammiano.png';

import Tips from '../images/tips.png';
import PayperView from '../images/payper.png';
import Bonus from '../images/bonus.png';
import SafeSecure from '../images/safesecure.png';
import Messenger from '../images/messenger.png';
import Statistics from '../images/statistics.png';

import SignUpBG from '../images/signup-bg.png';

const Guest = () => {
    const [followers, setFollowers] = useState(10000);
    const [price, setPrice] = useState(5);

    return <div className="main-content homepage-container-logged-out">
        <Meta />
        <div className="homepage-banner logged-out">
            <div className="banner-container">
                <div className="banner-logo" style={{ padding: '200px 0' }}>
                    {/* <LazyLoadImage className="logo" src={Logo} />
                        <LazyLoadImage className="logo-text" src={PrivapostsLogo} /> */}
                </div>
                <div className="banner-content">
                    <div className="banner-btn-container logged-out">
                        <Link to="/register" className="btn btn-primary">Create your profile</Link>
                        <Link to="/login" className="btn btn-bordered">Log In</Link>
                    </div>
                    <br />
                    <div className="d-md-block d-none text-center text-white">
                        <div className="row">
                            <div className="col-12"><strong>Premium Subscription-based Social Media Platform </strong></div>
                        </div>
                    </div>
                    <div className="d-md-none text-center text-white two-line-text">
                        <div className="row">
                            <div className="col-12"><strong>Premium Subscription-based</strong></div>
                            <div className="col-12"><strong>Social Media Platform</strong></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="section services second-section">
            <div className="row services-content">
                <div className="col-sm-3 col-md-6 col-lg-3 text-center">
                    <LazyLoadImage className="service-img" src={SocialInfluencer} />
                    <h3 className="service-title">
                        Make $$ From
                        <br />
                        Your Followers
                    </h3>
                    <p className="service-text">
                        A premium social media platform for all types of creators, influencers & celebrities to make money from their followers for their premium content.
                    </p>
                    <div className="service-text">
                        <ul className="text-left">
                            <li>Your content is locked until your followers pay to subscribe to you.</li>
                            <li>Make money from monthly subscription payments, tips, donations, selling Pay Per View content, and from referring other creators!</li>
                            <li>Tools for charities & businesses to raise funds for a cause/project</li>
                            <li>Platform for agencies to manage & earn referral income from their talent</li>
                        </ul>
                    </div>
                </div>
                <div className="col-sm-3 col-md-6 col-lg-3 text-center">
                    <LazyLoadImage className="service-img" src={ContentCreator} />
                    <h3 className="service-title">
                        For All Content
                        <br />
                        Creators
                    </h3>
                    <p className="service-text">
                        All types of content creators:
                        <br />
                        Celebrities, influencers, models, fitness bloggers, youtubers, cosplayers, photographers, musicians, artists, gamers, educators. The list is endless.
                    </p>
                </div>
                <div className="col-sm-3 col-md-6 col-lg-3 text-center">
                    <LazyLoadImage className="service-img" src={UncensoredContent} />
                    <h3 className="service-title">
                        Post Exclusive
                        <br />
                        Content
                    </h3>
                    <p className="service-text">All you have to do is post your premium exclusive content; behind the scenes footage, exclusive posts, tutorials, previews, customised content, photos, videos, or simply selfies to generate a recurring income from your biggest fans.</p>
                </div>
                <div className="col-sm-3 col-md-6 col-lg-3 text-center">
                    <LazyLoadImage className="service-img" src={EarnPay} />
                    <h3 className="service-title">
                        Fastest Way
                        <br />
                        To Earn Big Pay
                    </h3>
                    <div className="service-text">
                        <p className="service-text">You earn 5% (LIFETIME) of all Subscription income, tips, and Pay per View Message revenue made by any user that joins Privaposts.com via your referral URL. It does not include income your referred user earns through their own <a className="text-white" href="/referrals"><u>referrals</u></a>.</p>
                        <p className="service-text">Your unique referral code can be found on your "My Settings" page or your "Become a creator" page.</p>
                    </div>
                </div>
            </div>
        </div>

        <div className="section workflow">
            <h3 className="section-title text-center">How to Earn Lots Quickly!</h3>
            <div className="row workflow-content">
                <div className="col-sm-4 col-lg-2">
                    <div className="workflow-icon-title">
                        <LazyLoadImage src={SignUp} />
                        <h3 className="workflow-title">Sign Up</h3>
                    </div>
                    <p>
                        Free sign up!
                        <br />
                        Instantly become a creator once you set your subscription price allowing you to gain subscribers, post content and earn money.
                    </p>
                </div>
                <div className="col-sm-4 col-lg-2 col-half-offset">
                    <div className="workflow-icon-title">
                        <LazyLoadImage src={Price} />
                        <h3 className="workflow-title">Price</h3>
                    </div>
                    <p>
                        Choose whatever subscription price you like. Your followers have to pay this price to access your content.
                        Change your subscription price anytime.
                    </p>
                </div>
                <div className="col-sm-4 col-lg-2 col-half-offset">
                    <div className="workflow-icon-title">
                        <LazyLoadImage src={PostContent} />
                        <h3 className="workflow-title">Post Content</h3>
                    </div>
                    <p>
                        Post photos & videos on your profile.
                        <br />
                        Send photos, videos & Pay Per View content privately in the messenger.
                        <br />
                        We recommend 10-15 posts before you launch!
                    </p>
                </div>
                <div className="col-sm-4 col-lg-2 col-half-offset">
                    <div className="workflow-icon-title">
                        <LazyLoadImage src={Promote} />
                        <h3 className="workflow-title">Promote</h3>
                    </div>
                    <p>
                        Share your Privasposts profile (<b>privaposts.com/username</b>) on all your social media accounts - Instagram, Facebook, Twitter, Snapchat, YouTube, etc. Post censored previews of your content to entice subscriptions.
                    </p>
                </div>
                <div className="col-sm-4 col-lg-2 col-half-offset">
                    <div className="workflow-icon-title">
                        <LazyLoadImage src={EarnMoney} />
                        <h3 className="workflow-title">Earn $$</h3>
                    </div>
                    <p>
                        You keep 80% of everything you earn from your subscribers including subscription payments,
                        tips/donations, and Pay Per View content
                    </p>
                </div>
            </div>
        </div>

        <div className="section testimonials">
            <div className="testimonial-items-container">
                <div className="testimonial-item">
                    <p>I made over $42,000 in less than 2 weeks! I could not believe it! I had around 40,000 Instagram followers at the time. I uploaded 5 exclusive workout videos to my profile, and then I just posted previews of those same videos to Instagram, Facebook and Snapchat!</p>
                    <div className="testimonial-author-container">
                        <LazyLoadImage className="author-img" src={Bonhammiano} />
                        <div className="testimonial-detail">
                            <p className="author-name">Bonhammiano</p>
                            <p className="author-position">Australian model & influencer</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="section video-promo">
            <iframe src="https://www.youtube.com/embed/DUwgs0E1m7s" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" />
        </div>

        <div className="section earn">
            <h2 className="text-center">How Much Could You Earn?</h2>
            <div className="row earn-content">
                <p className="earn-field">
                    Social Media Followers{' '}<input
                        type="number"
                        inputMode="numeric"
                        className="followers ml-1"
                        value={followers}
                        onChange={(e) => setFollowers(e.target.value)}
                    />
                </p>
                <p className="earn-field">
                    Subscription Price $ <input
                        type="number"
                        className="subscription-price ml-1"
                        value={price}
                        onChange={(e) => setPrice(e.target.value)}
                        inputMode="decimal"
                    />
                </p>
                <p className="earn-estimate-field">
                    Your estimated* earnings would be between
                    <b>
                        {' '}
                        $
                        {Math.round(0.01 * 0.8 * followers * price)}
                    </b>
                    {' '}
                    and
                    <b>
                        {' '}
                        $
                        {Math.round(0.05 * 0.8 * followers * price)}
                    </b>
                    {' '}
                    per month
                </p>
                <p className="earn-notice">
                    *Estimate is based on between 1% and 5% of your followers subscribing and receiving 80% commission.
                    <br />
                    On average 8% to 10% of our content creators' followers on social media would pay for exclusive content.
                </p>
            </div>
        </div>

        <div className="section services">
            <h2 className="text-center"><b>Everything You Need To Make More Money!</b></h2>
            <div className="row services-content">
                <div className="col-sm-4">
                    <LazyLoadImage className="service-img" src={Tips} />
                    <h4 className="service-title">Tips & Donations</h4>
                    <p className="service-text">Receive tips and donations from your subscribers. Post more content and interact with your subscribers to increase their support. Subscribers can utilise the tip button to support your fundraising for a specific project.</p>
                </div>
                <div className="col-sm-4">
                    <LazyLoadImage className="service-img" src={PayperView} />
                    <h4 className="service-title">Pay Per View Messages</h4>
                    <p className="service-text">Send direct photo or video messages to your subscribers that remain locked until they pay the price you set for that message. You can send a Pay Per View message to all subscribers at once.</p>
                </div>
                <div className="col-sm-4">
                    <LazyLoadImage className="service-img" src={Bonus} />
                    <h4 className="service-title">Refer a Friend Bonus</h4>
                    <p className="service-text">You earn 5% (LIFETIME) of all Subscription income, tips, and Py Per View Message revenue made by any user that joins Privaposts.com via your referral URL. It does not include income your referred user earns through their own referrals.</p>
                </div>
                <div className="col-sm-4">
                    <LazyLoadImage className="service-img" src={SafeSecure} />
                    <h4 className="service-title">Safe & Secure</h4>
                    <p className="service-text">Secure SSL encryption with a world leading provider Geo Trust Secure data. DMCA Copyright protection on your content and no downloads.</p>
                </div>
                <div className="col-sm-4">
                    <LazyLoadImage className="service-img" src={Messenger} />
                    <h4 className="service-title">Messenger System</h4>
                    <p className="service-text">Only subscribers an send you direct messages. Send photos & videos and interact on a more personal level with your most loyal followers.</p>
                </div>
                <div className="col-sm-4">
                    <LazyLoadImage className="service-img" src={Statistics} />
                    <h4 className="service-title">Statistics & Reports</h4>
                    <p className="service-text">Performance tracking and visibility of key statistics. Look up your top paying followers. View monthly earnings for the past 12 months.</p>
                </div>
            </div>
        </div>

        <div className="section signup" style={{ background: `#0d0214 url(${SignUpBG}) no-repeat center center / cover` }}>
            <h3 className="text-center">Start Creating Now!</h3>
            <p className="signup-btn homepage">
                <Link to="/register" className="btn btn-primary">Sign Up</Link>
            </p>
        </div>
    </div>;
};

export default Guest;